import { useTranslation } from "react-i18next";
import Badge from "../../badge/badge";
import { EngineResult } from "../../../api/remappingService";
import { useState, useEffect } from "react";
import AnimatedChangeRow from "./animatedChangeRow";

interface RemappingResultsTableProps {
  changes: EngineResult | undefined;
  offlineSettingsForCurrentLanguage: {
    records: { header: string; description: string }[];
  } | undefined;
}

const RemappingResultsTable: React.FC<RemappingResultsTableProps> = ({
  changes,
  offlineSettingsForCurrentLanguage,
}) => {
  const { t } = useTranslation();
  const [hasAnimated, setHasAnimated] = useState(false);

  // Запускаем анимацию один раз при появлении данных
  useEffect(() => {
    if (changes?.recordsTypes?.length && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [changes, hasAnimated]);

  if (!changes) return null;

  return (
    <>
      {changes.recordsTypes && changes.recordsTypes.length > 0 && (
        <div className="space-y-6">
          {changes.recordsTypes.map((change, index) => (
            <AnimatedChangeRow
              key={index}
              name={change.name}
              power={change.power}
              torque={change.torque}
              shouldAnimate={hasAnimated}
            />
          ))}
        </div>
      )}

      {changes.patches && changes.patches.length > 0 && (
        <div className="max-w-screen-2xl w-full place-self-center max-md:p-4 py-2
            bg-tablebg rounded-xl border-tableline/50 pt-4">
          <div className="text-center mb-4">
            <h2 className="text-lg text-foreground/70 mb-2 px-1 font-medium">{t("Available options:")}</h2>
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {changes.patches.map((patch, index) => (
              <Badge
                key={`patch-${index}`}
                id={`patch-${index}`}
                checkboxText={patch}
                tooltipText={
                  offlineSettingsForCurrentLanguage?.records.find(
                    (x) => x.header === patch
                  )?.description ?? ""
                }
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RemappingResultsTable;